/**
 * Hard delete, no undo — the app's one major-toast anchor (MajorToast), same
 * convention as UsersPage/UserDeletedToast.jsx.
 */
import React from "react";
import MajorToast from "../../component/Toast/MajorToast";

const AUTO_DISMISS_MS = 6000;

const OrganizationDeletedToast = ({ name, onDismiss }) => (
  <MajorToast
    title="Organization deleted"
    text={name ? `${name} has been deleted.` : "The organization has been deleted."}
    duration={AUTO_DISMISS_MS}
    onDismiss={onDismiss}
  />
);

export default OrganizationDeletedToast;
